/**
 * The universal grade scale — ONE ladder for cross-gym normalization, shared by
 * the client (`constants.js` re-exports it) and the Cloud Functions (the
 * registration callables place a climber's global level on it).
 */
// Universal grade scale for cross-gym normalization — ONE ladder, four label
// systems. Each rung carries both the boulder labels (Font / V-scale) and the
// lead labels (French / UIAA), plus the shared `normPoints`. Global scoring uses
// a single scale for every discipline; the discipline only decides which label
// pair is shown (boulder → font/v, lead → french/uiaa). A gym maps each of its
// (colour) difficulty levels to a rung via `gradeRange`, so a lead gym picks by
// French/UIAA and a boulder gym by Font/V — same ladder, same points.
// Rows 20-23 (V12-V15 / XI-…XII-) extend above the historical V11/8a+/X+ ceiling
// for the country's hardest real lines (e.g. Kis-Gerecse). Additive — existing
// routes reference gradeId 0-19 only, so this changes no existing scoring.
export const GRADE_SCALE = [
  { gradeId: 0,  font: "3",    v: "VB",   french: "4a",  uiaa: "IV",    normPoints: 50 },
  { gradeId: 1,  font: "4a",   v: "V0",   french: "4b",  uiaa: "IV+",   normPoints: 100 },
  { gradeId: 2,  font: "4b",   v: "V0+",  french: "4c",  uiaa: "V-",    normPoints: 130 },
  { gradeId: 3,  font: "4c",   v: "V1",   french: "5a",  uiaa: "V",     normPoints: 160 },
  { gradeId: 4,  font: "5a",   v: "V2",   french: "5b",  uiaa: "V+",    normPoints: 200 },
  { gradeId: 5,  font: "5b",   v: "V2+",  french: "5c",  uiaa: "VI-",   normPoints: 240 },
  { gradeId: 6,  font: "5c",   v: "V3",   french: "6a",  uiaa: "VI",    normPoints: 280 },
  { gradeId: 7,  font: "6a",   v: "V3+",  french: "6a+", uiaa: "VI+",   normPoints: 330 },
  { gradeId: 8,  font: "6a+",  v: "V4",   french: "6b",  uiaa: "VII-",  normPoints: 380 },
  { gradeId: 9,  font: "6b",   v: "V4+",  french: "6b+", uiaa: "VII",   normPoints: 430 },
  { gradeId: 10, font: "6b+",  v: "V5",   french: "6c",  uiaa: "VII+",  normPoints: 480 },
  { gradeId: 11, font: "6c",   v: "V5+",  french: "6c+", uiaa: "VIII-", normPoints: 540 },
  { gradeId: 12, font: "6c+",  v: "V6",   french: "7a",  uiaa: "VIII",  normPoints: 600 },
  { gradeId: 13, font: "7a",   v: "V7",   french: "7a+", uiaa: "VIII+", normPoints: 670 },
  { gradeId: 14, font: "7a+",  v: "V8",   french: "7b",  uiaa: "IX-",   normPoints: 750 },
  { gradeId: 15, font: "7b",   v: "V8+",  french: "7b+", uiaa: "IX",    normPoints: 830 },
  { gradeId: 16, font: "7b+",  v: "V9",   french: "7c",  uiaa: "IX+",   normPoints: 920 },
  { gradeId: 17, font: "7c",   v: "V10",  french: "7c+", uiaa: "X-",    normPoints: 1010 },
  { gradeId: 18, font: "7c+",  v: "V10+", french: "8a",  uiaa: "X",     normPoints: 1110 },
  { gradeId: 19, font: "8a",   v: "V11",  french: "8a+", uiaa: "X+",    normPoints: 1220 },
  { gradeId: 20, font: "8a+",  v: "V12",  french: "8b+", uiaa: "XI-",   normPoints: 1320 },
  { gradeId: 21, font: "8b",   v: "V13",  french: "8c",  uiaa: "XI",    normPoints: 1420 },
  { gradeId: 22, font: "8b+",  v: "V14",  french: "8c+", uiaa: "XI+",   normPoints: 1520 },
  { gradeId: 23, font: "8c",   v: "V15",  french: "9a",  uiaa: "XII-",  normPoints: 1620 },
];

/**
 * Is `idx` a rung of `GRADE_SCALE`? Stored grade indexes (votes, spray
 * hardest-send tallies) come from client writes, so every reader checks before
 * it looks up a label.
 */
export function isGradeScaleIndex(idx) {
  return Number.isInteger(idx) && idx >= 0 && idx < GRADE_SCALE.length;
}
